export default __webpack_public_path__ + "static/media/modulo-consegna.e52f58a6.pdf";